import {
  AVAILABLE_SEATS,
  INVITES_BY_ID,
  USERS_INVITES,
  VALIDATE_INVITE_TOKEN,
} from '@mm/api-routes';
import { ObjectUtils } from '@mm/utils';
import { USER_ROLES } from '../model/CompanyUsersModel';
import InviteModel from '../model/InviteModel';
import AuthenticatedController from './AuthenticatedController';

type ValidateInviteResponse = {
  success: boolean;
  teamPricePlan: boolean;
  companyId: number;
  companyName: string;
  emailOnly?: boolean;
  allowEmailLogin?: boolean;
  existingUser?: boolean;
};

const mapInvite = (payload: Partial<InviteModel>) => {
  return {
    ...payload,
    role: payload.role ? USER_ROLES[payload.role] : undefined,
    allowedFacebookPageIds: payload.allowedFacebookPageIds
      ? payload.allowedFacebookPageIds.join(',')
      : payload.allowedFacebookPageIds,
  } as InviteModel;
};

export default class InvitesController extends AuthenticatedController {
  static async getAll(companyId: number): Promise<InviteModel[]> {
    const { invites } = await super.get(
      USERS_INVITES(companyId, 1, 1000, 'pending'),
    );
    return invites.map(mapInvite);
  }

  static getAvailableSeats(companyId: number): Promise<number[]> {
    return super.get(AVAILABLE_SEATS(companyId));
  }

  static async create(
    companyId: number,
    invite: Partial<InviteModel>,
  ): Promise<InviteModel> {
    const response = await super.post(
      USERS_INVITES(companyId),
      mapInvite(invite),
    );
    return mapInvite(response.invite);
  }

  static async update(entity: Partial<InviteModel>): Promise<InviteModel[]> {
    const mappedEntity = mapInvite(entity);
    const response = await super.put(INVITES_BY_ID(entity.id), mappedEntity);
    return [mapInvite(response.invite)];
  }

  static async destroy(invite: InviteModel) {
    return super.delete(INVITES_BY_ID(invite.id));
  }

  static async validateInviteToken(
    inviteToken: string,
  ): Promise<ValidateInviteResponse> {
    try {
      return await super.get(VALIDATE_INVITE_TOKEN(inviteToken));
    } catch (err) {
      throw ObjectUtils.deepCamelizeKeys(await err.json());
    }
  }
}
